import ChefHatIcon from 'assets/icons/chef-hat.svg';
import FoodBowlIcon from 'assets/icons/food-bowl.svg';
import FruitsAndVegetablesIcon from 'assets/icons/fruits-and-vegetables.svg';
import MeatIcon from 'assets/icons/meat-new.svg';
import NoAdditivesIcon from 'assets/icons/no-additives.svg';
import NoGrainsIcon from 'assets/icons/no-grains.svg';
import useMobile from 'hooks/common/use-mobile';
import { FormattedMessage } from 'react-intl';

/**
 * Nutrition USPs. This is the section that is displayed on the landing page for new customers and both dogs and cats.
 */
const NutritionUsps: React.FC = () => {
  const isMobile = useMobile();
  const usps = [
    {
      id: 'grains',
      icon: <NoGrainsIcon className="w-full" />,
    },
    {
      id: 'meat',
      icon: <MeatIcon className="w-full" />,
    },
    {
      id: 'additives',
      icon: <NoAdditivesIcon className="w-full" />,
    },
    {
      id: 'texture',
      icon: <FoodBowlIcon className="w-full" />,
    },
    {
      id: 'fruits',
      icon: <FruitsAndVegetablesIcon className="w-full" />,
    },
    {
      id: 'gentle',
      icon: <ChefHatIcon className="w-full" />,
    },
  ];

  return (
    <div className="lg:flex lg:w-full">
      <div
        className="mt-2 grid grid-cols-1 gap-1 lg:mt-4 lg:grow lg:grid-cols-3 lg:gap-x-3 lg:gap-y-5"
        data-test="nutrition-usps"
      >
        {usps.map(({ id, icon }) => (
          <div key={id} className="flex items-center gap-1.5 lg:block">
            <div className="flex h-11 w-11 items-center justify-center lg:mx-auto lg:h-16 lg:w-16">
              {icon}
            </div>
            <div className="mt-0.5 text-center font-medium leading-tight">
              <FormattedMessage
                id={`landingpage:nutrition-usps:${id}`}
                values={{ br: isMobile ? ' ' : <br /> }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NutritionUsps;
